import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {attachWorkspaceFilterState} from '../../utils/workspaceStateUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class AdminTractorGrid extends BaseComponent {
	
	static get properties() {
		return {			
			accountmanagement: {type: Boolean}
		};
	}
	
	constructor() {
		super();
		
		this.accountmanagement = false;
		
		var adminTractorGrid = this;
		setTimeout(function(){
			adminTractorGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var adminTractorGrid = this;
		
		var toolbarFilter = ElementUtil.create({
			tag: 'dl-toolbar',
		'collapse-label': 'Filter',
			slot: 'toolbar',
			theme: 'spacing',			
			children: [				
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterCompany',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Company',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,
					postinit: function(combo) {
						if (adminTractorGrid.accountmanagement) {
							Service.getAccountManagementService().getManagedCompanies().then(function(data){
								var lookups = []; 
								data.forEach(function(c) {
									lookups.push({
										code: c.companyId,
										description: c.companyName
									});
								});
								combo.items = lookups;
							});
						} else {
							Service.getCompanyService().getCompaniesLookup().then(function(data){
								combo.items = data;
							});
						}
					},
					placeHolder: 'Select',
					listeners: {
						change: function() {
							adminTractorGrid.selectedCompanyId = ElementUtil.query(toolbarFilter, 'filterCompany').value;
							actionRefresh();
						}
					}					
				},
				{
					tag: 'vaadin-combo-box',
					itemid: 'status',						
					'class': 'spacer-toolbar-item',
					'item-value-path': 'code',
					'item-label-path': 'desc',
					'prevent-invalid-input': true,
					postinit: function(combo) {							
						combo.items = [
							{
								code: 'A',
								desc: 'Active'
							}, {
								code: 'I',
								desc: 'Inactive'
							},
							{
								code: 'STG',
								desc: 'Stage'
							},
							{
								code: 'D',
								desc: 'Soft Delete'
							},
							{
								code: 'H',
								desc: 'History'
							}
						];
						combo.value = 'A';
					},
					listeners: {
						'selected-item-changed': function(event) {
							if (actionRefresh){
								actionRefresh();
							}
						}
					}					
				},
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterType',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Filter By',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,
					value: 'tractorRefNo',
					postinit: function(combo) {						
						var lookups = [
							{
								code: 'tractorId',
								description: 'Tractor Id'								
							},
							{
								code: 'tractorRefNo',
								description: 'Reference No'	
							},
							{
								code: 'tractorVinNo',
								description: 'VIN'	
							},
							{
								code: 'driverRefNo',
								description: 'Driver Ref No'	
							},
							{
								code: 'teamDriverRefNo',
								description: 'Team Driver Ref No'	
							},
							{
								code: 'division',
								description: 'Divison'	
							},
							{
								code: 'comment',
								description: 'Comment'	
							},							
							{
								code: 'tags',
								description: 'Tag'	
							}
						];
						combo.items = lookups;						
					},
					placeHolder: 'Select'					
				},				
				{
					tag: 'vaadin-text-field',
					itemid: 'filterValue',
					'class': 'spacer-toolbar-item',
					'keep-open': true,
					label: 'Filter Value',
					listeners: {
						input: {
							fn: function() {
								actionRefresh();
							},
							buffer: 2000
					    }
					}
				}
			]
		});		
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'toggleStatus',
					theme: '',
					'class': 'spacer-toolbar-item',					
					permissions: ['ADMIN_TRACTORS:UPDATE_STATUS'],							
					children:[
						ElementUtil.makeIcon('vaadin:check', 'Toggle Active Status')						
					],
					listeners: {
						click: function() {
							actionToggleStatus(grid.selectedItems);
						}
					}							
				},
				{
					tag: 'dl-action-button',
					itemid: 'toggleBilling',
					theme: '',
					'class': 'spacer-toolbar-item',					
					permissions: ['ADMIN_TRACTORS:UPDATE_STATUS'],							
					children:[
						ElementUtil.makeIcon('vaadin:flag', 'Toggle Billing Flag')						
					],
					listeners: {
						click: function() {
							actionToggleBilling(grid.selectedItems);
						}
					}							
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'merge',
					theme: '',
					'class': 'spacer-toolbar-item',					
					permissions: ['ADMIN_TRACTORS:UPDATE_STATUS'],							
					children:[
						ElementUtil.makeIcon('vaadin:compress', 'Merge')						
					],
					listeners: {
						click: function() {
							actionMerge(grid.selectedItems);
						}
					}							
				},
				{
					tag: 'div',
					style: 'float: right;',
					children:[
						{
							tag: 'dl-action-button',
							itemid: 'deleteMPGOverrides',
							theme: 'error primary',
							'class': 'spacer-toolbar-item',					
							permissions: ['ADMIN_TRACTORS:DELETE'],							
							children:[
								ElementUtil.makeIcon('vaadin:close', 'Delete MPG Overrides')						
							],
							listeners: {
								click: function() {
									actionDeleteMPGOverrides(grid.selectedItems);
								}
							}							
						},
						{
							tag: 'span',
							innerHTML: '|'
						},
						{
							tag: 'dl-action-button',
							itemid: 'deleteStage',
							theme: 'error primary',
							'class': 'spacer-toolbar-item',					
							permissions: ['ADMIN_TRACTORS:DELETE'],							
							children:[
								ElementUtil.makeIcon('vaadin:close', 'Delete Staging')						
							],
							listeners: {
								click: function() {
									actionDeleteStage(grid.selectedItems);
								}
							}							
						},						
						{
							tag: 'span',
							innerHTML: '|'
						},
						{
							tag: 'dl-action-button',
							itemid: 'delete',
							theme: 'error primary',					
							permissions: ['ADMIN_TRACTORS:DELETE'],
							'class': 'spacer-toolbar-item',								
							children:[
								ElementUtil.makeIcon('vaadin:trash', ' Delete')
							],
							listeners: {
								click: function() {
									actionDelete(grid.selectedItems);
								}
							}
						}
					]
				}											
			]
		});		
		
		var toolbarContainer = ElementUtil.create({
			tag: 'div',
			slot: 'toolbar',
			children: [
				toolbarFilter,
				ElementUtil.create({
					tag: 'hr'
				}),
				toolbar
			]
		});			
	
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [
				{
					tag: 'vaadin-grid-selection-column',
					itemid: 'selectionColumn',
					'auto-select': true,
					'auto-width': true,
					listeners: {
						'select-all-changed': function() {
							gridSelectionChange();
						}
					}					
				},				
				{						
					path: 'tractorId',
					header: 'Tractor Id',
					width: '7em'
				},	
				{						
					path: 'tractorRefNo',
					header: 'Reference No',
					width: '7em'
				},	
				{						
					path: 'tractorVinNo',
					header: 'Vin',
					width: '7em'
				},
				{						
					path: 'manualBillingFlag',
					header: 'Manual Billing',
					'text-align': 'center',
					width: '7em'
				},							
				{						
					path: 'comment',
					header: 'Comment',
					width: '7em'
				},
				{						
					path: 'tags',
					header: 'Tags',
					width: '12em',
					renderer: function(root, column, rowData) {
						var tags = [];
						if (rowData.item.tags) {
							rowData.item.tags.forEach(function(tagItem) {
								tags.push(
									'<span class="tag-badge" style="margin: 3px;">' + tagItem + '</span>'
								);
							});
						}
						root.innerHTML = tags.join('');
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
				},
				'click': function(e) {
					gridSelectionChange();
				}
			}
		});	
			
		var gridSelectionChange = function() {
			setTimeout(function(){
				if (grid.selectedItems.length > 0) {					  
					var status = ElementUtil.query(toolbarFilter, 'status').value;
					
					ElementUtil.query(toolbar, 'delete').disabled = false;
					if ('STG' === status) {
						ElementUtil.query(toolbar, 'deleteStage').disabled = false; 						
						ElementUtil.query(toolbar, 'toggleStatus').disabled = true;
						ElementUtil.query(toolbar, 'toggleBilling').disabled = true;
						ElementUtil.query(toolbar, 'merge').disabled = true;
					} else {
						ElementUtil.query(toolbar, 'deleteStage').disabled = true; 	
						ElementUtil.query(toolbar, 'toggleStatus').disabled = false;
						ElementUtil.query(toolbar, 'toggleBilling').disabled = false;
						ElementUtil.query(toolbar, 'deleteMPGOverrides').disabled = false;
						
						if (grid.selectedItems.length <= 2) {
							ElementUtil.query(toolbar, 'merge').disabled = false;
						} else {
							ElementUtil.query(toolbar, 'merge').disabled = true;
						}						
					}
				} else {						
					ElementUtil.query(toolbar, 'delete').disabled = true;			
					ElementUtil.query(toolbar, 'deleteStage').disabled = true; 
					ElementUtil.query(toolbar, 'toggleStatus').disabled = true;
					ElementUtil.query(toolbar, 'toggleBilling').disabled = true;
					ElementUtil.query(toolbar, 'merge').disabled = true;
					ElementUtil.query(toolbar, 'deleteMPGOverrides').disabled = true;
				}
			});
		};	
			
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 50,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var selectedCompany = ElementUtil.query(toolbarFilter, 'filterCompany').value;
					if (!selectedCompany) {						
						window.DL.MessageUtil.showToastError('A company must be selected.');
						return;
					}
					
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
												
						grid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'updateDts',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',							
							status: ElementUtil.query(toolbarFilter, 'status').value,
							filterField: ElementUtil.query(toolbarFilter, 'filterType').value,
							filterValue: ElementUtil.query(toolbarFilter, 'filterValue').value
						};
						
						var successHandler = function(records) {
							loadMask.remove();
							
							grid.selectedItems = [];
							grid.activeItem = null;						
							grid.items = records.data;
							gridSelectionChange();

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();						
						};
						
						
						grid.currentFilter.companyId = selectedCompany;
						UnitService.getAdminUnitService().getTractors(selectedCompany, grid.currentFilter).then(function(records){
							successHandler(records);
						});
																			
					};	
					
					loadData();
														
				};
			},
			listeners: {
				ready: function() {					
					//pagingToolbar.loadCurrentPage();					
				}
			}
			
		});			
		
		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'tractor',
			onDetail: function() {
				var exportFilter = Object.assign({}, grid.currentFilter || {});
				delete exportFilter.offset;
				delete exportFilter.max;
				UnitService.getTractorService().exportTractors(exportFilter);
			}
		});

		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbarContainer,
				grid,
				footer.footerContainer
			]
		});		
		adminTractorGrid.append(flexLayout);		
			
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);	
		};
		attachWorkspaceFilterState(adminTractorGrid, toolbarFilter, ['filterCompany','status','filterType','filterValue'], actionRefresh);
			
		var actionDeleteStage = function(records) {
			var requestModel = {
				ids: []
			};			
			records.forEach(function(item){				
				requestModel.ids.push(item.tractorId);
			});
			
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete the selected tractor(s) from staging?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing...');

							UnitService.getAdminUnitService().deleteStageTractors(adminTractorGrid.selectedCompanyId, requestModel)
							.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed', {									
									theme: 'success'
								});
								actionRefresh();
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});			
			
		};
	
		var actionDelete = function(records) {
	
			var requestModel = {
				ids: []
			};			
			records.forEach(function(item){				
				requestModel.ids.push(item.tractorId);
			});
			
			var deleteWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Confirm Delete',
				icon: 'vaadin:trash',				
				width: .75,
				height: 325,
				listeners: {
					ready: function() {						
						deleteWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'div',
											colspan: 2,
											trustedInnerHTML: true,
											innerHTML: 'Are you sure you want to delete the selected tractor(s)? <br>They will be marked Soft Delete immediately and removed in a background task.'
										},
										{
											tag: 'vaadin-checkbox',
											name: 'skipDataLockCheck',
											label: 'Skip Datalock Check'
										},																			
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary error',
													children: [
														ElementUtil.makeIcon('vaadin:trash', ' Delete')
													],
													listeners: {
														click: function() {															
																												
															var data = formPanel.getData();															
															var loadMask = grid.showLoading('Removing...');
															UnitService.getAdminUnitService().deleteTractorsBulk(adminTractorGrid.selectedCompanyId, data.skipDataLockCheck, requestModel)
															.then(function () {
																loadMask.remove();
																window.DL.MessageUtil.showToast('Success', 'Tractor removal scheduled. Marked Soft Delete (see Tasks).', {
																	theme: 'success'
																});
																actionRefresh();
																deleteWin.close();
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															deleteWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						deleteWin.addToContentElement(formPanel);
					}
				}
			});						
					
		};	
		
		var actionToggleStatus = function(records) {
			var requestModel = {
				ids: []
			};			
			var status;
			records.forEach(function(item){				
				if (!status) {
					status = item.activeStatus;
				}
				requestModel.ids.push(item.tractorId);
			});			
			if (status === 'A') {
				var loadMask = grid.showLoading('Inactivating...');
				UnitService.getAdminUnitService().inactivateTractor(adminTractorGrid.selectedCompanyId, requestModel).then(function(){
					loadMask.remove();
					window.DL.MessageUtil.showToast('Success', 'Inactivated Tractors', {
						theme: 'success'
					});
					actionRefresh();
				}).catch(function(){
					loadMask.remove();
				});
			} else {
				var loadMask = grid.showLoading('Activating...');
				UnitService.getAdminUnitService().activateTractor(adminTractorGrid.selectedCompanyId, requestModel).then(function(){
					loadMask.remove();
					window.DL.MessageUtil.showToast('Success', 'Activated Tractors', {
						theme: 'success'
					});
					actionRefresh();
				}).catch(function(){
					loadMask.remove();
				});
			}
		};		
		
		var actionToggleBilling = function(records) {
			var requestModel = {
				ids: []
			};			
			var manual;
			records.forEach(function(item){				
				manual = item.manualBillingFlag;
				requestModel.ids.push(item.tractorId);
			});			
			if (manual) {
				var loadMask = grid.showLoading('Flagging as Auto Bill...');
				UnitService.getAdminUnitService().autoBillTractor(adminTractorGrid.selectedCompanyId, requestModel).then(function(){
					loadMask.remove();
					window.DL.MessageUtil.showToast('Success', 'Flagged Tractors as Auto Bill', {
						theme: 'success'
					});
					actionRefresh();
				}).catch(function(){
					loadMask.remove();
				});
			} else {
				var loadMask = grid.showLoading('Flagging as Manual Bill..');
				UnitService.getAdminUnitService().manualBillTractor(adminTractorGrid.selectedCompanyId, requestModel).then(function(){
					loadMask.remove();
					window.DL.MessageUtil.showToast('Success', 'Flagged Tractors as Manual Bill', {
						theme: 'success'
					});
					actionRefresh();
				}).catch(function(){
					loadMask.remove();
				});
			}			
		};
				
		var actionDeleteMPGOverrides = function(records) {
			
			var tractorIds = [];		
			records.forEach(function(item){				
				tractorIds.push(item.tractorId);
			});			
			
			var deleteMPGOverrideWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Confirm Delete of MPG Override',
				icon: 'vaadin:trash',				
				width: .75,
				height: 325,
				listeners: {
					ready: function() {						
						deleteMPGOverrideWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'div',
											colspan: 2,
											innerHTML: 'Are you sure you want to delete the selected tractor(s) MPG Overrides?'
										},
										{
											tag: 'vaadin-date-picker',
											'class': 'spacer-toolbar-item',											
											label: 'Effective Date',												
											name: 'rawEffectiveDate'
										},
										{
											tag: 'vaadin-combo-box',
											label: 'Match Type',
											name: 'matchType',
											'item-value-path': 'code',
											'item-label-path': 'description',
											value: 'EQUALS',
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('DateMatchType').then(function (data) {
													combo.items = data;
												});
											}
										},
										{
											tag: 'vaadin-checkbox',
											name: 'emptyOverridesOnly',
											label: 'Empty Overrides Only'
										},																			
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary error',
													children: [
														ElementUtil.makeIcon('vaadin:trash', ' Delete')
													],
													listeners: {
														click: function() {															
																												
															var data = formPanel.getData();						
															
															data.companyId = adminTractorGrid.selectedCompanyId;
															data.tractorIds = tractorIds;
															
															var loadMask = grid.showLoading('Removing Overrides...');
															UnitService.getAdminUnitService().deleteMPGOverrides(data)
															.then(function () {
																loadMask.remove();
																window.DL.MessageUtil.showToast('Success', 'Removed Overrides', {
																	theme: 'success'
																});
																actionRefresh();
																deleteMPGOverrideWin.close();
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															deleteMPGOverrideWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						deleteMPGOverrideWin.addToContentElement(formPanel);
					}
				}
			});									
			
		};		
		
		var actionMerge = function(records) {
			
			var tractorIdFrom;
			var tractorIdTo;
			var tractorIdFromRef;
			var tractorIdToRef;
			if (records.length >= 1) {		
				tractorIdFrom = records[0].tractorId;
				tractorIdFromRef = records[0].tractorRefNo;
			}
			if (records.length >= 2) {	
				tractorIdTo = records[1].tractorId;
				tractorIdToRef = records[1].tractorRefNo;
			}
			
			var mergeWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Merge Tractors',
				icon: 'vaadin:compress',				
				width: .75,
				height: 325,
				listeners: {
					ready: function() {						
						mergeWin.show();
						
						var loadReferenceLookup = function(options) {
							
							UnitService.getAdminUnitService().getTractors(adminTractorGrid.selectedCompanyId, {
								max: 100,
								sortField: 'tractorRefNo',
								filterField: 'tractorRefNo',
								filterValue: options.filterValue
							}).then(function (response) {
								options.combo.items = response.data;
								if (options.initialValue) {
									options.combo.value = options.initialValue;
								}
								options.combo.required = true;
							});
							
						};
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [										
										{
											tag: 'vaadin-combo-box',
											label: 'Merge From',
											name: 'fromTractorId',
											'item-value-path': 'tractorId',
											'item-label-path': 'tractorRefNo',											
											postinit: function (combo) {
												loadReferenceLookup({
													combo: combo,
													filterValue: tractorIdFromRef,
													initialValue: tractorIdFrom
												});												
											},											
											listeners: {
												input: {
													fn: function(e) {														
														loadReferenceLookup({
															combo: e.target,
															filterValue: e.target.value
														});	
													},
													buffer: 500
												}
											}
										},
										{
											tag: 'vaadin-combo-box',
											itemId: 'toTractor',
											label: 'To',
											name: 'toTractorId',
											'item-value-path': 'tractorId',
											'item-label-path': 'tractorRefNo',
											postinit: function (combo) {
												loadReferenceLookup({
													combo: combo,
													filterValue: tractorIdToRef,
													initialValue: tractorIdTo
												});	
											},
											listeners: {
												input: {
													fn: function(e) {														
														loadReferenceLookup({
															combo: e.target,
															filterValue: e.target.value
														});	
													},
													buffer: 500
												}
											}
										},																			
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:compress', ' Merge')
													],
													listeners: {
														click: function() {															
																												
															var data = formPanel.getData();
															if (data.fromTractorId === data.toTractorId) {
																ElementUtil.query(formPanel, 'toTractor').errorMessage('From and To tractor need to be different.');
																ElementUtil.query(formPanel, 'toTractor').invalid = true;
																window.DL.MessageUtil.showToastError('From and To tractor need to be different.');
															} else {
																data.companyId = adminTractorGrid.selectedCompanyId;

																var loadMask = grid.showLoading('Submitting Merge Task...');
																UnitService.getAdminUnitService().mergeTractor(data)
																		.then(function () {
																			loadMask.remove();
																			window.DL.MessageUtil.showToast('Success', 'Submitted Merge Task', {
																				theme: 'success'
																			});
																			actionRefresh();
																			mergeWin.close();
																		});
															}
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															mergeWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						mergeWin.addToContentElement(formPanel);
					}
				}
			});			
			
			
		};		
				
		
	}
	
}
customElements.define('dl-admin-tractor-grid', AdminTractorGrid);